(() => {
  const same = (a, b) => String(a) === String(b);
  const findVariant = (variants, options) => variants.find(variant => variant.options.every((value, index) => same(value, options[index])));
  const availableSize = (variants, options, sizeIndex, size) => variants.some(variant => variant.available && variant.options.every((value, index) => index === sizeIndex ? same(value, size) : options[index] == null || same(value, options[index])));
  if (typeof module !== 'undefined' && module.exports) module.exports = { findVariant, availableSize };
  if (typeof document === 'undefined') return;

  function enhance(root) {
    if (root.dataset.qfEnhanced) return;
    const dataNode = root.querySelector('[data-qf-product]');
    if (!dataNode) return;
    const data = JSON.parse(dataNode.textContent);
    const sizeIndex = data.options.findIndex(name => name.toLowerCase() === 'size');
    root.dataset.qfEnhanced = 'true';
    const requestedId = new URL(window.location.href).searchParams.get('variant');
    let requestedVariant = data.variants.find(variant => same(variant.id, requestedId));
    if (requestedVariant && !requestedVariant.options.every((value, index) => same(value, root.querySelector(`[data-qf-option-index="${index}"] input:checked`)?.value))) requestedVariant = null;
    let chosenSize = requestedVariant?.options[sizeIndex] ?? null;
    let pending = false;
    let applying = false;
    const options = () => data.options.map((name, index) => root.querySelector(`[data-qf-option-index="${index}"] input:checked`)?.value ?? null);
    const form = () => root.querySelector('product-form-component form');
    const button = () => form()?.querySelector('[name="add"]');
    const status = root.querySelector('[data-qf-size-status]');
    const setText = (node, text) => { if (node && node.textContent !== text) node.textContent = text; };
    const disable = () => {
      const submit = button();
      if (!submit) return;
      if (!submit.disabled) submit.disabled = true;
      if (chosenSize === null) setText(submit.querySelector('.add-to-cart-text') || submit.querySelector('span'), data.selectSize);
    };
    const clearUnselectedVariantUrl = () => {
      if (root.dataset.updateUrl === 'false' || chosenSize !== null) return;
      const url = new URL(window.location.href);
      if (!url.searchParams.has('variant')) return;
      url.searchParams.delete('variant');
      window.history.replaceState(window.history.state, '', url);
    };
    const labelGallery = () => {
      const labels = { '2019050201-beige-03.jpg': data.front, '2019050201-beige-04.jpg': data.back, '2019050201-beige-05.jpg': data.texture };
      root.querySelectorAll('[data-media-src]').forEach(item => {
        const filename = item.dataset.mediaSrc?.split('?')[0].split('/').pop();
        const label = labels[filename];
        if (!label) return;
        if (item.matches('button, [role="button"]') && item.getAttribute('aria-label') !== label) item.setAttribute('aria-label', label);
        item.querySelectorAll('img').forEach(img => { if (img.alt !== label) img.alt = label; });
      });
    };
    function reconcile() {
      if (applying) return;
      applying = true;
      try {
        labelGallery();
        if (sizeIndex < 0) return;
        const sizeGroup = root.querySelector(`[data-qf-option-index="${sizeIndex}"]`);
        if (!sizeGroup) return;
        const selection = options();
        selection[sizeIndex] = chosenSize;
        if (chosenSize !== null && !availableSize(data.variants, selection, sizeIndex, chosenSize) && !same(findVariant(data.variants, selection)?.id, requestedVariant?.id)) {
          chosenSize = null;
          selection[sizeIndex] = null;
          setText(status, data.sizeCleared);
        }
        sizeGroup.querySelectorAll('input[type="radio"]').forEach(input => {
          input.checked = chosenSize !== null && same(input.value, chosenSize);
          const unavailable = !availableSize(data.variants, selection, sizeIndex, input.value);
          if (input.disabled !== unavailable) input.disabled = unavailable;
          input.classList.toggle('disabled', unavailable);
          const label = sizeGroup.querySelector(`label[for="${input.id}"]`);
          if (label) label.classList.toggle('qf-pdp__unavailable', unavailable);
        });
        if (chosenSize === null) {
          root.dataset.qfNeedsSize = 'true';
          clearUnselectedVariantUrl();
          disable();
          return;
        }
        delete root.dataset.qfNeedsSize;
        const expected = findVariant(data.variants, selection);
        const currentId = form()?.querySelector('[name="id"]')?.value;
        const renderedNode = root.querySelector('variant-selects [data-selected-variant]');
        let renderedVariant;
        try { renderedVariant = JSON.parse(renderedNode?.textContent || 'null'); } catch { renderedVariant = null; }
        const ready = expected?.available && same(expected.id, currentId) && same(expected.id, renderedVariant?.id);
        if (pending && ready) pending = false;
        if (!ready || pending) disable();
      } finally {
        applying = false;
      }
    }
    root.addEventListener('change', event => {
      const input = event.target;
      if (!input.matches('variant-selects input[type="radio"]') || sizeIndex < 0) return;
      const group = input.closest('[data-qf-option-index]');
      if (!group) return;
      requestedVariant = null;
      const index = Number(group.dataset.qfOptionIndex);
      if (index === sizeIndex) {
        const selection = options();
        if (!availableSize(data.variants, selection, sizeIndex, input.value)) {
          event.preventDefault();
          event.stopImmediatePropagation();
          chosenSize = null;
          reconcile();
          return;
        }
        chosenSize = input.value;
        setText(status, '');
      } else if (chosenSize !== null && !availableSize(data.variants, options(), sizeIndex, chosenSize)) {
        chosenSize = null;
        root.querySelectorAll(`[data-qf-option-index="${sizeIndex}"] input`).forEach(size => { size.checked = false; });
        setText(status, data.sizeCleared);
      }
      pending = true;
      disable();
      queueMicrotask(reconcile);
    }, true);
    root.addEventListener('submit', event => {
      if (!event.target.matches('product-form-component form') || sizeIndex < 0) return;
      const selected = options();
      selected[sizeIndex] = chosenSize;
      const expected = findVariant(data.variants, selected);
      const currentId = event.target.querySelector('[name="id"]')?.value;
      if (chosenSize === null || pending || !expected?.available || !same(expected.id, currentId)) {
        event.preventDefault();
        event.stopImmediatePropagation();
        reconcile();
        root.querySelector(`[data-qf-option-index="${sizeIndex}"] input:not([disabled])`)?.focus();
      }
    }, true);
    const observer = new MutationObserver(reconcile);
    observer.observe(root, { subtree: true, childList: true, attributes: true, attributeFilter: ['disabled', 'value'] });
    reconcile();
    customElements.whenDefined('product-form-component').then(reconcile);
    window.addEventListener('pageshow', reconcile);
  }
  const init = () => document.querySelectorAll('[data-qf-pdp]').forEach(enhance);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true }); else init();
  document.addEventListener('shopify:section:load', init);
})();
